let apiConfig = {
    API_URL: "https://vectus-backend.vercel.app",

};



export default apiConfig;
